import Seo from "../components/Seo";
import { BUSINESS } from "../lib/site";

const Section = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-heading text-xl font-black text-white">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-white/70">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <Seo
        title="Privacy Policy | Velocity Electrical Surplus"
        description="Privacy policy for Velocity Electrical Surplus — how we handle the information you submit through our website."
      />
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <h1 className="font-heading text-4xl font-black text-white">PRIVACY POLICY</h1>
        <p className="mt-3 text-sm text-white/60">
          {BUSINESS.nameUpper} — {BUSINESS.address}
        </p>

        <Section title="Information We Collect">
          <p>
            When you use our contact form or purchasing offer form, we collect the information
            you provide: your name, company name, phone number, email address, location,
            equipment details, and any photographs you upload.
          </p>
        </Section>

        <Section title="How We Use Your Information">
          <p>
            We use submitted information solely to evaluate your equipment or materials,
            prepare a purchasing offer, and communicate with you about your inquiry. Photos
            you upload are used only to evaluate the material you wish to sell.
          </p>
        </Section>

        <Section title="Storage and Security">
          <p>
            Submissions are stored securely in our website database and delivered to our
            business email. Access to stored submissions is restricted to authorized company
            personnel. We retain submissions only as long as needed to handle your inquiry and
            any resulting transaction.
          </p>
        </Section>

        <Section title="Sharing">
          <p>
            We do not sell, rent, or share your personal information with third parties for
            marketing purposes. Information may be disclosed only if required by law.
          </p>
        </Section>

        <Section title="Your Choices">
          <p>
            You may request that we delete your submission and photos at any time by contacting
            us at{" "}
            <a href={BUSINESS.emailHref} className="text-ves-green underline" data-testid="privacy-email-link">
              {BUSINESS.email}
            </a>{" "}
            or by calling{" "}
            <a href={BUSINESS.phoneTel} className="text-ves-green underline" data-testid="privacy-phone-link">
              {BUSINESS.phoneDisplay}
            </a>
            .
          </p>
        </Section>

        <Section title="Changes to This Policy">
          <p>
            We may update this policy from time to time. The current version is always
            available on this page.
          </p>
        </Section>

        <Section title="Image Credits">
          <p>
            Equipment photographs on this site are licensed stock or openly licensed real
            product photographs, including the following Wikimedia Commons images:
          </p>
          <ul className="list-disc space-y-1.5 pl-5">
            <li>
              &ldquo;Cable Wire Reels&rdquo; by Tony Webster,{" "}
              <a href="https://commons.wikimedia.org/wiki/File:Cable_Wire_Reels_(22926050163).jpg" target="_blank" rel="noopener noreferrer" className="text-ves-green underline" data-testid="credit-wire-link">
                CC BY-SA 2.0
              </a>
            </li>
            <li>
              &ldquo;630 Amps Molded Case Circuit Breaker&rdquo; by Balurbala,{" "}
              <a href="https://commons.wikimedia.org/wiki/File:630_Amps_Molded_Case_Circuit_Breaker.jpg" target="_blank" rel="noopener noreferrer" className="text-ves-green underline" data-testid="credit-breaker-link">
                CC BY-SA 3.0
              </a>
            </li>
            <li>&ldquo;Busduct&rdquo; by Achim Hering, public domain</li>
          </ul>
          <p>
            Manufacturer names and trademarks shown in photographs belong to their respective
            owners and do not imply any affiliation with Velocity Electrical Surplus.
          </p>
        </Section>
      </div>
    </div>
  );
}
